import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/_Pages/CategorySearch/index.tsx");
